export default "__VITE_ASSET__Cd8nMiHT__"